import request from '@/utils/request'

// 充值赠送规则
export interface IRechargeBonusRule {
  id?: number
  storeId?: number | null
  thresholdAmount: number
  bonusAmount: number
  enabled?: number
  sort?: number
}

// 规则列表
export function getRechargeBonusRuleList(params: { storeId?: number }) {
  return request({
    url: '/wallet/rechargeBonusRule/list',
    method: 'get',
    params
  })
}

export function createRechargeBonusRule(data: IRechargeBonusRule) {
  return request({
    url: '/wallet/rechargeBonusRule',
    method: 'post',
    data
  })
}

export function updateRechargeBonusRule(data: IRechargeBonusRule) {
  return request({
    url: '/wallet/rechargeBonusRule',
    method: 'put',
    data
  })
}

export function deleteRechargeBonusRule(id: number) {
  return request({
    url: `/wallet/rechargeBonusRule/${id}`,
    method: 'delete'
  })
}

export function setRechargeBonusRuleEnabled(id: number, enabled: number) {
  return request({
    url: `/wallet/rechargeBonusRule/${id}/enabled`,
    method: 'put',
    params: { enabled }
  })
}

export function rechargeBonusRuleMoveSort(params: { id: number | string; direction: 'up' | 'down' }) {
  return request({
    url: `/wallet/rechargeBonusRule/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })
}

export function rechargeBonusRuleSetSort(params: { id: number | string; sort: number }) {
  return request({
    url: `/wallet/rechargeBonusRule/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
}
